import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getVarSheetTemplates, downloadVarSheet } from "../../../../../api";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Modal from "../../../../components/modal";
import styles from "./styles.module.scss";
import toast from "react-hot-toast";
import useApplicationStore from "../../../../stores/application";

function DownloadVarSheet({ open, onClose }) {
  const activeApp = useApplicationStore((state) => state.activeApp);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getVarSheetTemplates()
      .then((res) => {
        if (res?.templates) {
          setTemplates(
            res.templates.map((t) => ({ value: t.value, label: t.label }))
          );
        }
        setIsLoading(false);
      })
      .catch(() => {
        setError("Failed to load VAR sheet templates");
        setIsLoading(false);
      });
  }, []);

  const handleDownload = () => {
    if (!selectedTemplate) {
      setError("Please select a VAR sheet template");
      return;
    }

    setError("");
    const toastId = toast.loading("Generating VAR Sheet...");
    setIsDownloading(true);

    downloadVarSheet(activeApp.id, {
      template: selectedTemplate.value,
    })
      .then((res) => {
        setIsDownloading(false);
        const blob = new Blob([res], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `VAR Sheet - ${activeApp.field_dba || activeApp.field_legalname || activeApp.id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast.success("VAR Sheet downloaded", { id: toastId });
      })
      .catch((err) => {
        setIsDownloading(false);
        const message =
          err?.data?.message || err?.message || "Failed to generate VAR Sheet";
        setError(message);
        toast.error(message, { id: toastId });
      });
  };

  return (
    <Modal isOpen={open} onClose={onClose} header={""} size="sm">
      <div className={styles.modalBody}>
        <h6 className={styles.heading}>Download VAR Sheet</h6>

        <div className={styles.fieldGroup}>
          <div>
            <label>VAR Sheet Template</label>
            {isLoading ? (
              <div className={styles.loadingText}>Loading templates...</div>
            ) : templates.length ? (
              <Select
                name="var-sheet-template"
                isLoading={isDownloading}
                isDisabled={isDownloading}
                options={templates}
                value={selectedTemplate}
                onChange={setSelectedTemplate}
                className={styles.selectInput}
                classNames={{
                  control: () => styles.selectControl,
                }}
                classNamePrefix="select"
                placeholder="Select a template..."
              />
            ) : (
              <div className={styles.noTemplatesText}>
                No templates available
              </div>
            )}
          </div>
        </div>

        {error && (
          <div className={styles.errorSection}>
            <p className={styles.errorText}>{error}</p>
          </div>
        )}
      </div>

      <div className={styles.modalFooter}>
        <ButtonIcon textColor="#254FE2" onClick={onClose}>
          Cancel
        </ButtonIcon>
        {selectedTemplate && (
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            disabled={isDownloading}
            onClick={handleDownload}
          >
            Download
          </ButtonIcon>
        )}
      </div>
    </Modal>
  );
}

export default DownloadVarSheet;
